"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViagerRatio = exports.usufructScale = void 0;
const ESubscriptionProductType_1 = require("../enums/ProductSubscribed/ESubscriptionProductType");
exports.usufructScale = [
    { minAge: 0, maxAge: 20, bareOwnership: 0.1, usufruct: 0.9 },
    { minAge: 21, maxAge: 30, bareOwnership: 0.2, usufruct: 0.8 },
    { minAge: 31, maxAge: 40, bareOwnership: 0.3, usufruct: 0.7 },
    { minAge: 41, maxAge: 50, bareOwnership: 0.4, usufruct: 0.6 },
    { minAge: 51, maxAge: 60, bareOwnership: 0.5, usufruct: 0.5 },
    { minAge: 61, maxAge: 70, bareOwnership: 0.6, usufruct: 0.4 },
    { minAge: 71, maxAge: 80, bareOwnership: 0.7, usufruct: 0.3 },
    { minAge: 81, maxAge: 90, bareOwnership: 0.8, usufruct: 0.2 },
    { minAge: 91, maxAge: 150, bareOwnership: 0.9, usufruct: 0.1 },
];
function getViagerRatio(age, subscriptionProductType) {
    if (!Number.isInteger(age) || age < 0)
        return null;
    const entry = exports.usufructScale.find((s) => age >= s.minAge && age <= s.maxAge);
    if (!entry)
        return null;
    return subscriptionProductType === ESubscriptionProductType_1.ESubscriptionProductType.usufruit ? entry.usufruct : entry.bareOwnership;
}
exports.getViagerRatio = getViagerRatio;
